"use strict";
/**
 * Addon Factory
 * formats the raw data into a usable format
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const DEFAULT_CURRENCY_1 = __importDefault(require("../../../constants/date/DEFAULT_CURRENCY"));
const LANG_1 = __importDefault(require("../../../constants/lang/LANG"));
const formatPriceValue_1 = __importDefault(require("../../utils/common/formatPriceValue"));
/**
 * Returns formated AddOn info
 * @param {AddOnType} addOnInfo
 * @param {string} language
 * @returns {AddOnFactoryType}
 */
function addOnFactory(addOnInfo, language = LANG_1.default.EN) {
    const currency = (0, get_1.default)(addOnInfo, 'currency', DEFAULT_CURRENCY_1.default);
    const price = (0, formatPriceValue_1.default)((0, get_1.default)(addOnInfo, 'price'), currency);
    const displayPrice = `+${price}`;
    return {
        id: (0, get_1.default)(addOnInfo, 'id'),
        code: (0, get_1.default)(addOnInfo, 'code', ''),
        name: (0, get_1.default)(addOnInfo, `name.${language}`, ''),
        description: (0, get_1.default)(addOnInfo, `description.${language}`, ''),
        price,
        currency,
        displayPrice,
    };
}
exports.default = addOnFactory;
